import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue
} from 'vuelidate/lib/validators'
import { zipCode } from '~/validations/validations.js'
import Form from '~/utils/mixins/form'

export default {
  mixins: [Form],
  components: {
    RadioBlock: () => import('~/components/commom/radio-block/index'), /// Replace with lib component
    DateBlock: () => import('~/components/commom/date-block/index'), /// Replace with lib component
    ErrorBlock: () => import('~/components/commom/error-block/index'), /// Replace with lib component
    SelectBlock: () => import('~/components/commom/select-block/index'), /// Replace with lib component
    InputBlock: () => import('~/components/commom/input-block/index'), /// Replace with lib component
    ButtonBlock: () => import('~/components/commom/button-block/index')
  },

  data() {
    return {
      constructionYear: '',
      reconstructionValue: null,
      reconstructionValueCheck: 0,
      grossPrivateArea: '',
      grossDependentArea: '',
      numberOfBathrooms: '',
      reconstructionContentValueCheck: false,
      interiorCapital: null,
      postalCode: null,
      type: null,
      typology: '',
      housePurpose: '',
      insuranceType: '',
      options: {
        typology: [
          {
            value: 't1',
            name: 'T1'
          },
          {
            value: 't2',
            name: 'T2'
          },
          {
            value: 't3',
            name: 'T3'
          },
          {
            value: 't4',
            name: 'T4'
          },
          {
            value: 't5',
            name: 'T5'
          }
        ],
        housePurpose: [
          {
            value: 1,
            name: this.$i18n.t('Permanent Housing') // this part need to be translated
          },
          {
            value: 2,
            name: this.$i18n.t('Secondary Housing') // this part need to be translated
          },
          {
            value: 3,
            name: this.$i18n.t('Local accommodation') // this part need to be translated
          }
        ],
        insuranceType: [
          {
            value: 1,
            name: this.$i18n.t('Building')
          },
          {
            value: 2,
            name: this.$i18n.t('Content')
          },
          {
            value: 3,
            name: this.$i18n.t('Building and Content')
          }
        ],
        type: [
          {
            value: 'E',
            name: this.$i18n.t('Home')
          },
          {
            value: 'F',
            name: this.$i18n.t('Fraction')
          }
        ]
      }
    }
  },

  validations: {
    constructionYear: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(4),
      maxValue: maxValue(new Date().getFullYear())
    },
    postalCode: {
      required,
      zipCode
    },
    typology: {
      required
    },
    housePurpose: {
      required
    },
    insuranceType: {
      required
    },
    type: {
      required
    },
    reconstructionValue: {
      required
    },
    grossPrivateArea: {
      required,
      minValue: minValue(1),
      maxValue: maxValue(10000)
    },
    grossDependentArea: {
      required,
      minValue: minValue(1),
      maxValue: maxValue(1000000000)
    },
    numberOfBathrooms: {
      required,
      maxLength: maxLength(2),
      minValue: minValue(1)
    },
    interiorCapital: {
      required
    }
  },

  computed: {
    houseDetails() {
      return {
        constructionYear: this.constructionYear,
        postalCode: this.postalCode,
        typology: this.typology,
        housePurpose: this.housePurpose,
        insuranceType: this.insuranceType,
        type: this.type,
        reconstructionValue: this.reconstructionValue,
        grossPrivateArea: this.grossPrivateArea,
        grossDependentArea: this.grossDependentArea,
        numberOfBathrooms: this.numberOfBathrooms,
        interiorCapital: this.interiorCapital,
        insurance_type: this.insuranceType
      }
    }
  },

  methods: {
    focusNextInput(ref) {
      event.preventDefault()
      this.$nextTick(() => {
        const element = this.$refs[ref].$el.querySelector('input')

        if (element === null) {
          return
        }

        element.focus()
      })
    },
    goToNextStep() {
      this.validateForm()

      if (this.$v.$invalid) {
        return
      }
      this.$emit('input', this.houseDetails)
    },
    validateForm() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => this.goToFirstError())
      }
    },
    scrollTo(element) {
      const elementPosition =
        element.getBoundingClientRect().top + document.documentElement.scrollTop
      const halfOfViewport =
        Math.max(
          document.documentElement.clientHeight,
          window.innerHeight || 0
        ) / 2

      window.scrollTo(0, elementPosition - halfOfViewport)
    },
    async reconstructionCalculator() {
      if (
        this.postalCode != null &&
        this.typology != null &&
        this.type != null
      ) {
        const params = {
          postalCode: this.postalCode,
          typology: this.typology,
          type: this.type
        }
        const values = await this.$axios.get(
          '/homeinsurance/reconstructionValue/',
          {
            params
          }
        )
        this.reconstructionValue = values.data.build
        this.interiorCapital = values.data.interior
        this.reconstructionValueCheck += 1
        this.reconstructionContentValueCheck = !this
          .reconstructionContentValueCheck
      }
    }
  },

  watch: {
    postalCode(value) {
      if (value === null || this.$v.postalCode.$invalid) {
        return
      }
      this.postalCode = value
    },
    typology(value) {
      if (value === null || this.$v.typology.$invalid) {
        return
      }
      this.typology = value
    },
    type(value) {
      if (value === null || this.$v.type.$invalid) {
        return
      }
      this.type = value
    }
  }
}
